import CluppTextArea from "../../../Components/CluppForms/CluppTextArea";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";

const ToDoBetter = ({ state, setState, field }) => {
  return (
    <>
      <TitleHeaders
        title={
          "¿Tienes algún comentario o sugerencia que nos ayude a mejorar? (opcional)🧐"
        }
        subtitle={""}
        isRequired={false}
      />
      <CluppTextArea
        state={state}
        label={"Mejoras en Clupp"}
        multiline={true}
        setState={setState}
        field={field}
        variant="filled"
        autoFocus={true}
      />
    </>
  );
};

export default ToDoBetter;
